// extracted by mini-css-extract-plugin
export default {"component":"Dialog-module__component-CWW4","panel":"Dialog-module__panel-ZStM","shaded":"Dialog-module__shaded-cxQs"};